@if(auth.user(); as user) {
@if (status() === 'pending') {
<div role="region" aria-label="Cookie consent" id="consent-banner"
  class="fixed bottom-0 left-0 w-full z-50 bg-primary text-white p-6 shadow-md">
  <div class="max-w-screen-2xl mx-auto">
    <div class="flex flex-col lg:flex-row flex-nowrap gap-8 lg:gap-16">
      <div class="flex flex-col flex-1">
        <h2 class="text-2xl font-bold">We use cookies (not the edible kind, sorry!)</h2>
        <p class="text-base leading-normal">Some cookies are essential to keep our website running (no switching those
          off, sorry), but we also use optional cookies. <a [routerLink]="['/pages', 'privacy-policy']">Find out
            more.</a></p>
      </div>

      <div class="flex flex-row items-center flex-nowrap gap-4">
        <button class="filled-button secondary" (click)="accept(user.is_guest)" title="Accept">Accept optional
          cookies</button>
        <button class="outline-button secondary" (click)="decline(user.is_guest)" title="Decline">Reject</button>
      </div>
    </div>
  </div>
</div>
}}